import { Error as CoreError, ErrorCodeEnum } from "./api/core";

export type Message =
  | {
      height: number;
      type: "resize";
      source: string;
    }
  | {
      type: "style";
      style: string;
      fonts: string[];
    }
  | {
      type: "ready";
    };

export type ValidationError = {
  errors: Array<{
    code: string;
    fieldPath: string;
  }>;
};

export type ApiError = Error & {
  cause: CoreError & {
    status: number;
  };
};

export const isErrorCode = (code: unknown): code is ErrorCodeEnum => {
  const validCodes: ErrorCodeEnum[] = [
    "invalidEmail",
    "maxEquity",
    "invalidCountry",
    "invalidPropertyType",
    "invalidMarketingType",
  ];
  return typeof code === "string" && validCodes.includes(code as ErrorCodeEnum);
};

export const isValidationError = (error: unknown): error is ApiError => {
  return (
    error instanceof Error &&
    "cause" in error &&
    error.cause !== null &&
    typeof error.cause === "object" &&
    "status" in error.cause &&
    error.cause.status === 422 &&
    "code" in error.cause &&
    isErrorCode(error.cause.code) &&
    "fieldPath" in error.cause
  );
};
